<template>
  <div>
    <div class="px-4">
      <div v-if="loading" class="spinner text-xs-center">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>
      <v-layout v-else row wrap class="ma-0">
        <v-flex v-if="isSetting" xs12>
          <div>
            <v-layout row wrap style="color: #969595;">
              <v-flex xs6>
                <div style="margin-top: 10px;">{{ $t('Use custom replies') }}</div>
              </v-flex>
              <v-flex xs6 class="text-xs-right">
                <toggle-button
                  class="mt-2"
                  :value="editcartsummary_status"
                  :sync="true"
                  :color="$vuetify.theme.success"
                  @change="changePatternStatus"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  style="display: inline-block"
                />
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
        <v-flex xs6 class="pr-1">
          <message-item
            v-model="cartsummary_pattern1"
            :patterntype="isProducts ? 'products' : 'setting'"
            :type="'1'"
            @onSave="onSavePattern"
          ></message-item>
        </v-flex>
        <v-flex v-if="!isProducts" xs6 class="pl-1">
          <message-item v-model="cartsummary_pattern2" :type="'2'"></message-item>
        </v-flex>
        <template v-if="!isSetting && !isProducts">
          <v-flex xs6 class="pr-4">
            <div class="flex-center">
              <v-radio-group
                @change="$emit('update:pattern', patternradio)"
                v-model="patternradio"
                class="ma-0"
              >
                <v-radio color="primary" :value="'1'"></v-radio>
              </v-radio-group>
            </div>
          </v-flex>
          <v-flex xs6 class="pl-4">
            <div class="flex-center">
              <v-radio-group
                @change="$emit('update:pattern', patternradio)"
                v-model="patternradio"
                class="ma-0"
              >
                <v-radio color="primary" :value="'2'"></v-radio>
              </v-radio-group>
            </div>
          </v-flex>
        </template>
      </v-layout>
    </div>
  </div>
</template>

<script>
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
import specialtext from '@/components/elements/specialtext'
import nl2br from 'vue-nl2br'
import MessageItem from './MessageItem'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  props: {
    isSetting: {
      default: false
    },
    isProducts: {
      default: false
    },
    pattern: {
      default: ''
    }
  },
  components: { ToggleButton, AutoresizeTextarea, specialtext, nl2br, MessageItem },
  data() {
    return {
      cartsummary_pattern1: {
        message1: '',
        message2: '',
        detailstatus: true,
        shippingstatus: true
      },
      cartsummary_pattern2: {
        message1: '',
        message2: '',
        detailstatus: true,
        shippingstatus: true
      },
      patternradio: '',
      editcartsummary_status: false,

      loading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    if (!this.isProducts) {
      this.getcartsummarypattern()
    } else {
      try {
        // console.log(this.pattern)
        this.cartsummary_pattern1 = JSON.parse(this.pattern)
      } catch (error) {}
    }
  },
  methods: {
    onSavePattern() {
      this.$emit('onSavePattern', this.cartsummary_pattern1)
    },
    changePatternStatus(e) {
      api.putcartsummarypatternstatus(
        {
          pageid: this.selectedBot.pageid,
          cartsummarypatternstatus: e.target.checked
        },
        (err, response) => {}
      )
    },

    getcartsummarypattern() {
      this.loading = true
      api.getcartsummarypattern({ pageid: this.selectedBot.pageid }, (err, response) => {
        this.loading = false
        if (response && response.responsecode == 200 && response.data) {
          try {
            if (response.data[0].cartsummary_pattern1) {
              this.cartsummary_pattern1 = JSON.parse(response.data[0].cartsummary_pattern1)
            }
          } catch (error) {}
          try {
            if (response.data[0].cartsummary_pattern2) {
              this.cartsummary_pattern2 = JSON.parse(response.data[0].cartsummary_pattern2)
            }
          } catch (error) {}
          this.editcartsummary_status = response.data[0].editcartsummary_status
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.readonly {
  background-color: #f3f3f3;
}
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/view/live/MessagePattern.vue